import { durationFormatter } from '@utils/durationFormatter'
import { formatNumber } from '@utils/numberFormatter'
import dayjs from 'dayjs'
import { FC } from 'react'

interface DateAxisTickProps {
  x: number
  y: number
  payload: {
    value: string
  }
  format?: string
}

export const DateAxisTick: FC<DateAxisTickProps> = ({
  x,
  y,
  payload,
  format = 'DD MMM',
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={20} y={0} dy={16} textAnchor="end" fill="#bbb">
        {dayjs(payload.value).format(format)}
      </text>
    </g>
  )
}

interface LabelAxisTickProps {
  x: number
  y: number
  payload: {
    value: string
  }
}

export const LabelAxisTick: FC<LabelAxisTickProps> = ({ x, y, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={20} y={0} dy={16} textAnchor="end" fill="#bbb">
        {payload.value}
      </text>
    </g>
  )
}

interface CenteredAxisTickProps {
  x: number
  y: number
  payload: {
    value: string
  }
}

export const CenteredAxisTick: FC<CenteredAxisTickProps> = ({
  x,
  y,
  payload,
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={10} textAnchor="middle" fill="#bbb">
        {payload.value}
      </text>
    </g>
  )
}

export const NumberFormatedAxisTick: FC<CenteredAxisTickProps> = ({
  x,
  y,
  payload,
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={10} textAnchor="end" fill="#bbb">
        {formatNumber(payload.value)}
      </text>
    </g>
  )
}

export const DurationFormatedAxisTick: FC<CenteredAxisTickProps> = ({
  x,
  y,
  payload,
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={10} textAnchor="end" fill="#bbb">
        {durationFormatter(Number(payload.value), 0) || '0s'}
      </text>
    </g>
  )
}
